<template>
  <v-data-table
    :headers="headers"
    :items="pages"
    :search="search"
    @click:row="onPageClick"
    class="elevation-1"
  >
  </v-data-table>
</template>
<script>
export default {
  name: "ContentList",
  props: ["search"],
  data() {
    return {
      headers: [
        { text: "Title", value: "navTitle" },
        { text: "Created by", value: "createdBy" },
        { text: "Created", value: "dateCreated" },
        { text: "Edited by", value: "editedBy" },
        { text: "Edited", value: "dateEdited" },
      ]
    };
  },
  mounted() {
    this.$store.dispatch("dispatchGetPages");
    console.log(this.$store.state.pages);
  },
  methods: {
    onPageClick(page) {
      this.$emit("selectPage", page);
    },
  },
  computed: {
      pages(){
        return this.$store.state.pages;
      }
  }
};
</script>
<style scoped>
.v-data-table {
  width: 100%;
}
</style>